import { Typography } from '@mui/material';

import { Button } from '~/components/Button';
import { Link } from '~/components/Link';
interface ApiGuestCardProps {
  loading: boolean;
}
export const ApiGuestCard = ({ loading }: ApiGuestCardProps) => {
  return (
    <>
      <Typography variant="h5">Create an account</Typography>
      <Typography variant="body1">
        A free account is required to use this API. Please{' '}
        <Link href="/login">log in</Link> or{' '}
        <Link href="/signup?reason=api.access">sign up</Link>.
      </Typography>
      <br />
      <Button
        loading={loading}
        variant="contained"
        href="/signup?reason=api.access">
        Sign Up
      </Button>
    </>
  );
};
